// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get, isEmpty} from 'lodash';

// Relative import
import actions from '../../actions/actions';
import VatInformation from './VatInformation';
import vatInformationActions from '../../actions/vatInformation';
import {getFormElementsIds, getSelectOptions} from '../utils/addressUtil';
import {vatRegex} from '../../utils/validate';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', '-1'),
        translations: state.app.translations,
        siteName: state.system.siteName,
        serviceError: get(state, 'vatInformation.serviceError', ''),
        enableContinueButton: get(state, 'vatInformation.enableContinueButton', false),
        vatMetadata: get(state, 'vatInformation.vatMetadata', {}),
        vatInformationCountry: get(state, 'vatInformation.vatInformationCountry', ''),
        vatNumber: get(state, 'vatInformation.vatNumber', ''),
        vatRegionCode: get(state, 'vatInformation.vatRegionCode', ''),
        vatAddressCountry: get(state, 'vatInformation.vatAddressCountry', ''),
        vatAddressLine1: get(state, 'vatInformation.vatAddressLine1', ''),
        vatAddressLine2: get(state, 'vatInformation.vatAddressLine2', ''),
        vatCity: get(state, 'vatInformation.vatCity', ''),
        vatStateSelect: get(state, 'vatInformation.vatStateSelect', ''),
        vatState: get(state, 'vatInformation.vatState', ''),
        vatPostalCode: get(state, 'vatInformation.vatPostalCode', ''),
        vatInfoCountryError: get(state, 'vatInformation.vatInfoCountryError', ''),
        vatNumberError: get(state, 'vatInformation.vatNumberError', ''),
        vatAddressCountryError: get(state, 'vatInformation.vatAddressCountryError', ''),
        vatAddressLine1Error: get(state, 'vatInformation.vatAddressLine1Error', ''),
        vatAddressLine2Error: get(state, 'vatInformation.vatAddressLine2Error', ''),
        vatCityError: get(state, 'vatInformation.vatCityError', ''),
        StateError: get(state, 'vatInformation.StateError', ''),
        StateSelectError: get(state, 'vatInformation.StateSelectError'),
        vatPostalCodeError: get(state, 'vatInformation.vatPostalCodeError', ''),
        infoIconClickedStatus: get(state, 'vatInformation.infoIconClickedStatus', false),
        vatRegionCodeOptions: get(state, 'vatInformation.vatRegionCodeOptions', []),
        isSaveModalOpen: get(state, 'app.isSaveModalOpen', false),
        isBillingSetupFlow: get(state, 'billingSetup.isBillingSetupFlow', false)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
        vatInformationActions: bindActionCreators(vatInformationActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class VatInformationContainer extends React.Component {
    constructor(props) {
        super(props);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.setVatInfoCountry = this.setVatInfoCountry.bind(this);
        this.setVatNumber = this.setVatNumber.bind(this);
        this.setVatRegionCodes = this.setVatRegionCodes.bind(this);
        this.setVatAddressCountry = this.setVatAddressCountry.bind(this);
        this.setVatAddressLine1 = this.setVatAddressLine1.bind(this);
        this.setVatAddressLine2 = this.setVatAddressLine2.bind(this);
        this.setVatCity = this.setVatCity.bind(this);
        this.setVatSelectState = this.setVatSelectState.bind(this);
        this.setVatState = this.setVatState.bind(this);
        this.setVatPostalCode = this.setVatPostalCode.bind(this);
        this.showOnFieldBlur = this.showOnFieldBlur.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.handleInfoIcon = this.handleInfoIcon.bind(this);
        this.closeInfoIcon = this.closeInfoIcon.bind(this);
        this.triggerEdapEventOnFocus = this.triggerEdapEventOnFocus.bind(this);
        this.handleSaveAndFinishOnClick = this.handleSaveAndFinishOnClick.bind(this);
        this.handleSaveModalClose = this.handleSaveModalClose.bind(this);
    }

    componentWillMount() {
        this.props.actions.enableLoadOverLay(true);
        this.props.vatInformationActions.getVatMetadata();
    }

    componentWillReceiveProps(nextProps) {
        if (this.isNonEmptyVatMetadata(nextProps)) {
            this.props.vatInformationActions.setVatField('Vat Information Country', nextProps.vatMetadata.companyCountryInfo.countryCode);
            this.props.vatInformationActions.getVatRegionCodes(nextProps.vatMetadata.companyCountryInfo.countryCode, nextProps.vatMetadata.vatRegionCodes);
        }
    }

    isNonEmptyVatMetadata = (nextProps) => isEmpty(this.props.vatMetadata) && !isEmpty(nextProps.vatMetadata);

    triggerEdapEventOnFocus(e) {
        this.props.actions.triggerEdapEvent('generic.event', {
            eventcategory: e.target.name,
            eventaction: `on Focus:Vat.${e.target.name}`,
            highfrequency: 'true'
        });
    }

    triggerEdapPageViewAction() {
        this.props.actions.triggerEdapPageView(this.props.publicUuid, 'VAT Information');
    }

    handleInfoIcon() {
        this.props.vatInformationActions.toggleInfoIcon(true);
    }

    closeInfoIcon() {
        this.props.vatInformationActions.toggleInfoIcon(false);
    }

    handleFormSubmit(event) {
        event.preventDefault();
        this.props.actions.enableLoadOverLay(true);
        const vatState = (this.props.vatState) ? this.props.vatState : this.props.vatStateSelect;
        const vatDetails = {
            'addresses': {
                'countryCode': this.props.vatInformationCountry,
                'vatNumber': this.props.vatNumber,
                'regionCode': this.props.vatRegionCode,
                'country': this.props.vatAddressCountry,
                'address1': this.props.vatAddressLine1,
                'address2': this.props.vatAddressLine2,
                'city': this.props.vatCity,
                'stateProvince': vatState,
                'postalCode': this.props.vatPostalCode
            }
        };
        this.props.actions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue',
            eventaction: 'VAT information submit'
        });

        this.props.vatInformationActions.updateVatDetails(vatDetails, this.props.isBillingSetupFlow);
    }

    setVatInfoCountry(event) {
        event.preventDefault();
        this.props.vatInformationActions.setVatField('Vat Information Country', event.target.value);
        this.setFieldsError('Vat.InformationCountry');
        this.props.vatInformationActions.getVatRegionCodes(event.target.value, this.props.vatMetadata.vatRegionCodes);
        this.props.actions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Vat Information Country selected',
            highfrequency: 'true'
        }, {});
        this.toggleButtonStatus();
    }

    setVatRegionCodes(event) {
        event.preventDefault();
        this.props.vatInformationActions.setVatField('Vat Region Code', event.target.value);
        this.setFieldsError('Vat.RegionCode');
        this.props.actions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Vat Region Code selected',
            highfrequency: 'true'
        }, {});
        this.toggleButtonStatus();
    }

    setVatNumber(event) {
        event.preventDefault();
        this.props.vatInformationActions.setVatField('Vat Number', event.target.value);
        this.validateVatNumber(event)
        this.toggleButtonStatus();
    }

    setVatAddressCountry(event) {
        event.preventDefault();
        this.props.vatInformationActions.setVatField('Vat Address Country', event.target.value);
        this.setFieldsError('country');
        this.props.actions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Vat Address Country selected',
            highfrequency: 'true'
        }, {});
        this.toggleButtonStatus();
    }

    setVatAddressLine1(event) {
        event.preventDefault();
        this.props.vatInformationActions.setVatField('Vat Address Line1', event.target.value);
        this.setFieldsError('address1');
        this.toggleButtonStatus();
    }

    setVatAddressLine2(event) {
        event.preventDefault();
        this.props.vatInformationActions.setVatField('Vat Address Line2', event.target.value);
        this.setFieldsError('address2');
        this.toggleButtonStatus();
    }

    setVatCity(event) {
        event.preventDefault();
        this.props.vatInformationActions.setVatField('Vat City', event.target.value);
        this.setFieldsError('city');
        this.toggleButtonStatus();
    }

    setVatPostalCode(event) {
        event.preventDefault();
        this.props.vatInformationActions.setVatField('Vat Postal Code', event.target.value);
        this.setFieldsError('postalCode');
        this.toggleButtonStatus();
    }

    setVatSelectState(event) {
        event.preventDefault();
        this.props.actions.triggerEdapEvent('generic.event', {
            eventcategory: 'State selected - Vat',
            eventaction: 'State selected - Vat',
            highfrequency: 'true'
        }, {});
        this.props.vatInformationActions.setVatField('Vat Select State', event.target.value);
        this.setFieldsError('stateProvince');
        this.toggleButtonStatus();
    }

    setVatState(event) {
        event.preventDefault();
        this.props.vatInformationActions.setVatField('Vat State', event.target.value);
        this.setFieldsError('stateProvince');
        this.toggleButtonStatus();
    }

    toggleButtonStatus() {
        this.props.vatInformationActions.enableContinueButton();
    }

    // eslint-disable-next-line complexity
    setFieldsError(errorField) {
        const addressFieldIds = getFormElementsIds();
        const fields = [
            'Vat.InformationCountry',
            'Vat.RegionCode'
        ].concat(addressFieldIds);

        for (let fieldVal of fields) {
            if (fieldVal === errorField) {
                this.props.vatInformationActions.setFieldError(fieldVal, '');
                break;
            }
            if ((fieldVal === 'Vat.InformationCountry' && !this.props.vatInformationCountry)
                || (fieldVal === 'Vat.RegionCode' && !this.props.vatRegionCode)
                || (fieldVal === 'country' && !this.props.vatAddressCountry)
                || (fieldVal === 'address1' && !this.props.vatAddressLine1)
                || (fieldVal === 'city' && !this.props.vatCity)
                || ((fieldVal === 'stateProvince') && !((this.props.vatState) ? this.props.vatState : this.props.vatStateSelect))
                || (fieldVal === 'postalCode' && !this.props.vatPostalCode)) {
                this.props.vatInformationActions.setFieldError(fieldVal, 'ipmob.input.field.required');
            }
        }
    }

    showOnFieldBlur(event) {
        event.preventDefault();
        if (!event.target.value) {
            this.setFieldsError(event.target.id);
            this.props.vatInformationActions.setFieldError(event.target.id, 'ipmob.input.field.required');
        } else if (event.target.id === 'Vat.Number') {
            this.validateVatNumber(event);
        }
    }

    validateVatNumber(event) {
        event.preventDefault();
        this.props.vatInformationActions.setFieldError(event.target.id, '');
        if (!event.target.value) {
            this.props.vatInformationActions.setFieldError(event.target.id, 'ipmob.input.field.required');
        } else if (!vatRegex.test(event.target.value)) {
                this.props.vatInformationActions.setFieldError(event.target.id, 'ipmob.input.field.vat_format');
        }
    }

    handleAlertDismiss() {
        this.props.vatInformationActions.alertError('');
    }

    handleSaveAndFinishOnClick() {
        this.props.actions.showSaveAndFinishModal(true);
    }

    handleSaveModalClose() {
        this.props.actions.showSaveAndFinishModal(false);
    }

    render() {
        const {translations, vatMetadata} = this.props;

        const companyCountryInfo = vatMetadata.companyCountryInfo;
        let countryName = (companyCountryInfo) ? companyCountryInfo.countryName : null;
        const vatCountryOptions = getSelectOptions(vatMetadata.countryList);

        return (
            <VatInformation
                translations={translations}
                vatMetadata={this.props.vatMetadata}
                handleFormSubmit={this.handleFormSubmit}
                vatCountryOptions={vatCountryOptions}
                companyLocationName={countryName}

                handleVatInfoCountryChange={this.setVatInfoCountry}
                vatInfoCountryValue={this.props.vatInformationCountry}
                vatInfoCountryError={this.props.vatInfoCountryError}
                onVatInfoCountryBlur={this.showOnFieldBlur}

                handleVatNumberChange={this.setVatNumber}
                vatNumberValue={this.props.vatNumber}
                vatNumberError={this.props.vatNumberError}
                onVatNumberBlur={this.showOnFieldBlur}

                handleVatRegionCodeChange={this.setVatRegionCodes}
                vatRegionCodeValue={this.props.vatRegionCode}
                vatRegionCodeOptions={this.props.vatRegionCodeOptions}
                onVatRegionCodeBlur={this.showOnFieldBlur}

                handleCountryChange={this.setVatAddressCountry}
                vatAddressCountryValue={this.props.vatAddressCountry}
                countryError={this.props.vatAddressCountryError}
                onCountryBlur={this.showOnFieldBlur}

                handleAddressLine1Change={this.setVatAddressLine1}
                addressLine1Val={this.props.vatAddressLine1}
                addressLine1Error={this.props.vatAddressLine1Error}
                onAddress1Blur={this.showOnFieldBlur}

                handleAddressLine2Change={this.setVatAddressLine2}
                addressLine2Val={this.props.vatAddressLine2}
                onAddress2Blur={this.showOnFieldBlur}

                handleCityChange={this.setVatCity}
                cityVal={this.props.vatCity}
                cityError={this.props.vatCityError}
                onCityBlur={this.showOnFieldBlur}

                handleSelectStateChange={this.setVatSelectState}
                stateSelectVal={this.props.vatStateSelect}
                onSelectedStateBlur={this.showOnFieldBlur}

                handleStateChange={this.setVatState}
                stateVal={this.props.vatState}
                stateError={this.props.StateError}
                onStateBlur={this.showOnFieldBlur}

                handlePostalCodeChange={this.setVatPostalCode}
                postalCodeVal={this.props.vatPostalCode}
                postalCodeError={this.props.vatPostalCodeError}
                onPostalCodeBlur={this.showOnFieldBlur}

                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}
                handleInfoIcon={this.handleInfoIcon}
                infoIconClickedStatus={this.props.infoIconClickedStatus}
                closeInfoIcon={this.closeInfoIcon}
                enableButton={this.props.enableContinueButton}
                triggerEdapEventOnFocus={this.triggerEdapEventOnFocus}

                handleSaveAndFinishOnClick={this.handleSaveAndFinishOnClick}
                isSaveModalOpen={this.props.isSaveModalOpen}
                handleSaveModalClose={this.handleSaveModalClose}

            />
        );
    }
}

VatInformationContainer.propTypes = {
    siteName: PropTypes.string,
    publicUuid: PropTypes.string,
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    enableContinueButton: PropTypes.bool,
    vatInfoCountryError: PropTypes.string,
    vatNumberError: PropTypes.string,
    vatAddressCountry: PropTypes.string,
    vatCityError: PropTypes.string,
    vatPostalCodeError: PropTypes.string,
    serviceError: PropTypes.string,
    isSaveModalOpen: PropTypes.bool,
    isBillingSetupFlow: PropTypes.bool
};
